import { render, staticRenderFns } from "./Overons.vue?vue&type=template&id=24076ca0&scoped=true&"
import script from "./Overons.vue?vue&type=script&lang=js&"
export * from "./Overons.vue?vue&type=script&lang=js&"
import style0 from "./Overons.vue?vue&type=style&index=0&id=24076ca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24076ca0",
  null
  
)

export default component.exports